export const products = {
  alerts: {
    successCreated: 'Votre produit a été envoyé pour approbation.',
    successDeleted: 'Votre produit a été supprimé.',
    successUpdated: 'Votre produit a été modifié.',
  },
  breadcrumb: {
    create: 'Créer un produit',
    edit: 'Modifier le produit',
    overview: 'Produits',
  },
  createEdit: {
    blocker: {
      create: 'Voulez-vous vraiment quitter cette page ? Votre produit n’a pas été enregistré.',
      edit: 'Voulez-vous vraiment quitter cette page ? Les modifications apportées à votre produit n’ont pas été enregistrées.',
    },
    details: {
      title: 'Détails du produit',
    },
    info: {
      description: 'Saisissez ici les informations de votre produit',
      title: 'Informations sur le produit',
    },
    submit: {
      create: 'Créer le produit',
      edit: 'Modifier le produit',
      save: 'Enregistrer',
    },
    title: {
      create: 'Nouveau produit',
      edit: 'Modifier le produit',
    },
  },
  fields: {
    activityType: {
      label: 'Type de prestation',
      placeholder: 'Type de prestation',
      tooltip:
        'Choisissez le type de prestation applicable. <a href="https://knowledge.creativeshelter.be/wanneer-factureer-je-welke-soort-prestatie" target="_blank">Vous hésitez ? Vérifiez ici quand facturer quelle prestation.</a>',
    },
    categories: {
      label: 'Catégories',
      placeholder: 'Ajoutez une catégorie, par exemple : montage, postproduction, traduction, révision finale, …',
    },
    name: {
      inLanguage: {
        en: 'Nom du produit en anglais',
        fr: 'Nom du produit en français',
        nl: 'Nom du produit en néerlandais',
      },
      label: 'Nom du produit',
      placeholder: 'Nom du produit',
    },
    price: {
      label: 'Prix (hors TVA)',
      tooltip:
        'Vous utilisez souvent le même prix pour votre produit ? Indiquez-le dès maintenant et épargnez-vous du travail. Vous pourrez encore le modifier lors de l’établissement de votre facture.',
    },
    unit: {
      label: 'Unité',
      placeholder: 'Choisissez une unité',
      tooltip:
        'Vous utilisez souvent la même unité pour votre produit ? Indiquez-la dès maintenant et épargnez-vous du travail. Vous pourrez encore la modifier lors de l’établissement de votre facture.',
    },
  },
  header: {
    actionBlock: {
      button: 'Créer un produit',
    },
    title: 'Produits',
  },
  modal: {
    add_one: 'Ajouter {{count}} produit',
    add_other: 'Ajouter {{count}} produits',
    add_zero: 'Ajouter des produits',
    createNew: 'Créer un nouveau produit',
    title: 'Ajouter des produits',
  },
  overview: {
    columns: {
      creativeWork: 'Type',
      name: 'Nom du produit',
      price: 'Prix',
      productCategories: 'Catégories',
      status: {
        options: {
          Approved: 'Approuvé',
          InReview: 'En attente d’approbation',
          Rejected: 'Refusé',
        },
        title: 'Statut',
      },
    },
    deleteModal: {
      description: 'Voulez-vous vraiment supprimer ce produit ?',
      title: 'Supprimer le produit',
    },
    infoCard: {
      instantInvoices: {
        description:
          'Une facture ne contenant que des produits approuvés ? Elle peut partir immédiatement chez votre client, sans vérification supplémentaire de notre part.',
        href: 'https://knowledge.creativeshelter.be/wat-is-instant-factureren',
        label: 'Plus d’infos',
        title: 'Facturation instantanée',
      },
      products: {
        description:
          'Une ligne de facture que vous créez une seule fois et que vous pouvez ensuite réutiliser à chaque fois sur une facture ou un devis.',
        href: 'https://knowledge.creativeshelter.be/producten-wat-zijn-ze-en-hoe-gebruik-je-ze',
        label: 'Plus d’infos',
        title: 'Produits',
      },
      title: 'Informations sur les produits',
    },
  },
};
